import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrCwtReturnOrderSearchComponent } from './kn-br-return-order-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        NgSelectModule,
        NgbModule,
        NgbTooltipModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CwtReturnOrderSearchComponent: {
                    component: KnBrCwtReturnOrderSearchComponent,
                },
            },
        } as CmsConfig),
        KnBrCwtReturnOrderSearchComponent,
    ],
})
export class KnBrReturnOrderSearchModule {}
